import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import FoodModalOption from "./FoodModalOption"
import classes from "./FoodModalOptionGroup.module.scss"

const FoodModalOptionGroup = props => {
  const { form, setForm, specification, maxSelect } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["title"]}>
        {
          specification.isRequired &&
          <span
            className={clsx(
              classes["isRequired"],
              isLtr && classes["isRequired-ltr"]
            )}
          >
            *
          </span>
        }
        <span className={classes["groupName"]}>
          {specification.groupName}
        </span>
        {
          specification.maxFreeQuantity > 1 &&
          <span
            className={clsx(
              classes["maxQuantity"],
              isLtr && classes["maxQuantity-ltr"]
            )}
          >
            {t("تا_maxFreeQuantity_عدد_افزودنی_رایگان", { maxFreeQuantity: specification.maxFreeQuantity })}
          </span>
        }
      </div>

      <div className={classes["options"]}>
        {specification.specificationItems.map(specificationItem =>
          <FoodModalOption
            key={specificationItem._id}
            form={form}
            setForm={setForm}
            specification={specification}
            specificationItem={specificationItem}
            maxSelect={maxSelect}
          />
        )}
      </div>
    </Fragment>

  )
}

export default FoodModalOptionGroup
